module.exports = __webpack_public_path__ + "static/media/rhb.9de955f7.jpg";